import React from 'react';
import { CommonValidation } from '../CommonValidation/commonValidation';

type TabLinkProps = {
  /** The id used to pick the tab that was selected */
  id: string;
  /** A way to compare if the current tab is the selected one */
  selectedTab: string;
  /** A title to be shorter than standard if needed */
  shortTitle?: string;
  /** A standard title if a short title is not provided */
  title?: string;
  /** The number to appear in the badge if it's provided */
  badgeValue?: number;
  /** Any styling required for the tab when in selected state*/
  selectedStyle?: string;
  /** Decides what happens when the tab is clicked on */
  onSelect: (id: string) => void;
};

const TabLink = ({
  id,
  selectedTab,
  shortTitle,
  title,
  badgeValue,
  selectedStyle,
  onSelect
}: TabLinkProps): JSX.Element => {
  let classes = 'tablink';

  if (selectedTab === id) {
    classes += ' selected';

    if (CommonValidation.isNotEmpty(selectedStyle)) {
      classes += ` ${selectedStyle}`;
    }
  }

  if (CommonValidation.isEmpty(shortTitle)) shortTitle = title;

  const onDivClick = () => {
    onSelect(id);
  };

  return (
    <div className={classes} onClick={onDivClick}>
      <span className='d-md-none'>{shortTitle}</span>
      <span className='d-none d-md-inline-block'>{title}</span>
      {badgeValue && badgeValue > 0 && (
        <span className='badge badge-pill badge-primary badge-counter'>
          {badgeValue}
        </span>
      )}
    </div>
  );
};

export default TabLink;
